import { Component, OnInit, ElementRef, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from 'src/app/user/services/login.service';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css']
})
export class MenuComponent implements OnInit {

  @Input()
  isOpened: boolean;

  @Output()
  onMenuClose = new EventEmitter();

  constructor(
    private router: Router,
    private loginService: LoginService
  ) {
    
  }

  ngOnInit() {}

  get isSuperadmin() {
    return this.loginService.isSuperadmin();
  }

  toogleMenu() {
    this.isOpened = !this.isOpened;
    this.onMenuClose.next(this.isOpened);
  }

  closeRespMenu() {
    this.isOpened = false;
    this.onMenuClose.next(this.isOpened);
  }

}
